export default __webpack_public_path__ + "static/library-dc5548ec0155253964c02736ca210b4b.jpg";